import templateStr from 'text!./templates/back-button-navigation.html';

export default ['$state', '$filter', 'NavigationService', function ($state, $filter, NavigationService) {
    return {
        restrict: 'EA',
        scope: {},
        template: templateStr,
        link: function link(scope) {
            var navHistoryObj = NavigationService.recentHistory();
            scope.previous = navHistoryObj ? navHistoryObj.from : null;

            scope.goToPrevious = function () {
                if (scope.previous) {
                    if (scope.previous.params) {
                        $state.transitionTo(scope.previous.state.name, scope.previous.params);
                    } else {
                        $state.transitionTo(scope.previous.state.name);
                    }
                }
            };

            scope.getPreviousLabel = function () {
                var label = void 0;
                var prevState = scope.previous ? scope.previous.state : null;
                if (prevState) {
                    if (prevState.data) {
                        label = prevState.data.label ? prevState.data.label : prevState.name;
                    } else {
                        label = prevState.name;
                    }
                }
                return label ? $filter('translate')('platform.navigation.NavigationDirective.Back to') + ' ' + label : null;
            };
        }
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/platform/navigation/NavigationDirective.js
// module id = 1048
// module chunks = 0